import apiUrl from "../Apiurl";

// Rappresentazione interna del limite:
// - Infinity: nessun limite (API `unlimited: true`);
// - 0: traduzioni disattivate (variabile assente o 0, fail-closed);
// - null: limite non disponibile (risposta senza limite), traduzione bloccata.
export function parseTranslationQuota(response) {
  const row = response?.[0];
  if (!Number.isSafeInteger(row?.total) || row.total < 0) {
    throw new Error("Conteggio caratteri non valido");
  }
  if (row.unlimited === true) return { total: row.total, limit: Infinity };
  // Una risposta precedente resta leggibile, senza inventare un limite.
  const limit = row.limit ?? null;
  if (limit !== null && (!Number.isSafeInteger(limit) || limit < 0)) {
    throw new Error("Limite caratteri non valido");
  }
  // Contratto precedente (senza `unlimited`): li' `limit = 0` significava
  // nessun limite.
  if (row.unlimited === undefined && limit === 0) {
    return { total: row.total, limit: Infinity };
  }
  return { total: row.total, limit };
}

export function translationAllowed(total, limit) {
  return limit > 0 && total < limit;
}

export async function loadTranslationQuota(getAccessTokenSilently, signal) {
  const token = await getAccessTokenSilently();
  if (signal.aborted) throw new DOMException("Aborted", "AbortError");
  const response = await fetch(apiUrl + "/prodotti/translate/charcount", {
    headers: { Authorization: "Bearer " + token },
    signal,
  });
  if (!response.ok) throw new Error(`Conteggio caratteri non disponibile (${response.status})`);
  return parseTranslationQuota(await response.json());
}
